"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FACET_NAVIGATION_SET_OPEN_TAXONOMY_CLASSES = exports.FACET_NAVIGATION_SET_OPEN_ATTRIBUTES = exports.FACET_NAVIGATION_SET_OPEN_CATEGORIES = exports.FACET_NAVIGATION_SET_SEARCH_TERM = void 0;
const const_1 = require("../../const");
exports.FACET_NAVIGATION_SET_SEARCH_TERM = `${const_1.PREFIX_ENRICH}FACET_NAVIGATION_SET_SEARCH_TERM`;
exports.FACET_NAVIGATION_SET_OPEN_CATEGORIES = `${const_1.PREFIX_ENRICH}FACET_NAVIGATION_SET_OPEN_CATEGORIES`;
exports.FACET_NAVIGATION_SET_OPEN_ATTRIBUTES = `${const_1.PREFIX_ENRICH}FACET_NAVIGATION_SET_OPEN_ATTRIBUTES`;
exports.FACET_NAVIGATION_SET_OPEN_TAXONOMY_CLASSES = `${const_1.PREFIX_ENRICH}FACET_NAVIGATION_SET_OPEN_TAXONOMY_CLASSES`;
